import { Switch } from "@faire/web/ui/routing/Switch";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";

import * as RetailerPaths from "@faire/retailer/paths";

const MarketBrandDirectoryRouterBase = () => (
  <Suspense fallback={null}>
    <Switch>
      <Redirect to={RetailerPaths.home()} />
    </Switch>
  </Suspense>
);

export const MarketBrandDirectoryRouter = observer(
  MarketBrandDirectoryRouterBase
);
